var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ffcf04;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003893;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_259",
    "data-name": "Trazado 259",
    className: "cls-2",
    d: "M65.12,84.9h-19.69c-10.92-.01-19.76-8.86-19.78-19.78v-19.69c.01-10.92,8.86-19.76,19.78-19.78h19.69c10.92.01,19.76,8.86,19.78,19.78v19.69c-.01,10.92-8.86,19.76-19.77,19.78M45.43,30.75c-8.1,0-14.67,6.58-14.68,14.68v19.69c0,8.1,6.58,14.67,14.68,14.68h19.69c8.1,0,14.67-6.58,14.68-14.68v-19.69c0-8.1-6.58-14.67-14.68-14.68h-19.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_261",
    "data-name": "Trazado 261",
    className: "cls-2",
    d: "M74.11,39.73c0,1.98-1.6,3.58-3.58,3.58s-3.58-1.6-3.58-3.58,1.6-3.58,3.58-3.58h0c1.98,0,3.58,1.6,3.58,3.58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_260",
    "data-name": "Trazado 260",
    className: "cls-2",
    d: "M55.28,69.99c-8.13,0-14.71-6.59-14.71-14.71,0-8.13,6.59-14.71,14.71-14.71,8.13,0,14.71,6.59,14.71,14.71h0c0,8.12-6.59,14.7-14.71,14.71M55.28,45.66c-5.31,0-9.62,4.31-9.62,9.62s4.31,9.62,9.62,9.62,9.62-4.31,9.62-9.62h0c0-5.31-4.31-9.61-9.62-9.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1aa82bc1d9f4d5b87260a7b4a101ea56.svg";
export { ForwardRef as ReactComponent };